import { GetterTree } from 'vuex';
import { GroupModel } from '@descomplica/dex-models';

import RootState from '@/store/root_state';
import { GroupState } from './state';

const getters: GetterTree<GroupState, RootState> = {
  getGroupsByBoardsGroupId: (state, getters) => (boardsGroupId: number) => {
    if (!boardsGroupId) return [];

    return Object.values(state.groups)
      .filter(group => group.boardsGroupId === boardsGroupId)
      .map(group => new GroupModel(group, getters));
  },
  getGroupById: (state, getters) => (groupId: number) => {
    if (!groupId) return null;

    const group = state.groups[groupId.toString()];
    if (!group) return null;

    return new GroupModel(group, getters);
  },
};

export default getters;
